module.exports = {"id":"198640","name":"Zakaria Labyad","rating":"76","photo":"./data/images/photos/2/198640.png","club":{"name":"FC Utrecht","logo":"./data/images/clubs/FCUtrecht.png"},"positions":["MOC","AD","AG","BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ZakariaLabyad0.json
// module id = 4460
// module chunks = 0